<mat-card *ngIf="!isRegistrationPage; else page">
    <ng-container *ngTemplateOutlet="page"></ng-container>
</mat-card>

<ng-template #page>
    <div *ngIf="showHeader" class="header">
        <div class="text-center">
            <img [alt]="companyName + ' Logo'" [src]="companyImg" class="w-25 mx-auto logoBg">
        </div>
        <div class="text-center">
            <h3>Welcome to {{ companyName }} community</h3>
        </div>
    </div>
    <div class="content">
        <form [formGroup]="eligibilityForm" class="mt-10 rowTwo mb-10">
            <ng-container *ngFor="let field of this.dynamicFormFields">
                <ng-container *ngIf="!field.hidden">
                    <div class="flex-col">
                        <b class="labelTitle">{{ field.text }}</b>
                        <div *ngIf="field.image">
                            <img [src]="field.image" class="max-w-100">
                        </div>
                        <mat-form-field
                                *ngIf="field.question_type !== 'date' else dateField "
                                appearance="outline" class="w-100"
                                color="accent">
                            <mat-label></mat-label>
                            <ng-container
                                    *ngIf="field.question_type == 'single_choice' || field.question_type == 'multiple_choice'">
                                <mat-select (selectionChange)="fieldSelect($event, field)"
                                            [formControlName]="field.id"
                                            [multiple]="field.question_type == 'multiple_choice'">
                                    <mat-option *ngFor="let option of field.options"
                                                [value]="option.id">{{ option.text }}
                                    </mat-option>
                                </mat-select>
                            </ng-container>
                            <ng-container *ngIf="field.question_type == 'text'">
                                <input [formControlName]="field.id" matInput type="text">
                            </ng-container>
                            <mat-error *ngIf="eligibilityForm.controls[field.id].hasError('required')">
                                This field is required
                            </mat-error>
                            <mat-hint *ngIf="field.help_text">{{ field.help_text }}</mat-hint>
                        </mat-form-field>
                        <ng-template #dateField>
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label></mat-label>
                                <input [formControlName]="field.id" [matDatepicker]="picker"
                                       [max]="field.is_dob? today : null" matInput>
                                <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error *ngIf="eligibilityForm.controls[field.id].hasError('required')">
                                    This field is required
                                </mat-error>
                                <mat-hint>{{ field.help_text }}</mat-hint>
                            </mat-form-field>
                        </ng-template>
                    </div>
                </ng-container>
            </ng-container>
        </form>
        <div class="w-100 text-center mt-20">
            <button (click)="checkEligibility()"
                    [disabled]="loading || eligibilityForm.invalid" class="mx-auto"
                    color="accent" mat-flat-button>
                Check eligibility
                <mat-icon *ngIf="loading">
                    <mat-spinner color="accent"></mat-spinner>
                </mat-icon>
            </button>
        </div>
    </div>

</ng-template>
